import React, { useState, useContext } from "react";
import moment from "moment";

import { PRIORITY } from '../../utils/priority';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faSmile, faListCheck, faClipboardList, faDownload, faPen, faRectangleXmark, faFloppyDisk, faFilePdf } from "@fortawesome/free-solid-svg-icons";

import opdContext from "../../context/opdContext/opdContext";
import controlGLBContext from "../../context/controlGLB/controlGLBContext";
import authContext from "../../context/authentication/authContex";

import '../ReqInfo/ReqInfo.css';

function OPDInfo({ item = {}, files = [], cerrar }) {

    const [opd, setOpd] = useState(item);
    const [editNota, setEditNota] = useState(false);
    const [editNotaReservada, setEditNotaReservada] = useState(false);
    const [editadoNota, setEditadoNota] = useState(false);
    const [editadoNotaReservada, setEditadoNotaReservada] = useState(false);

    const { modificarOPD } = useContext(opdContext);
    const { generarInformeReqPDF } = useContext(controlGLBContext);
    const { usuario } = useContext(authContext);

    const handleAbrirURL = (url) => {
        window.open(url);
    };

    const handleDownloadAll = () => {
        files?.forEach(file => {
            window.open(file.url);
        });
    };

    const handleEditNota = () => {
        setEditNota(!editNota);
    };

    const handleEditNotaReservada = () => {
        setEditNotaReservada(!editNotaReservada);
    };

    const handleModificaNota = (valor) => {
        setOpd({ ...opd, notePubl: valor });
        setEditadoNota(true);
    };

    const handleModificaNotaReservada = (valor) => {
        setOpd({ ...opd, notePriv: valor });
        setEditadoNotaReservada(true);
    };

    const saveChanges = async () => {
        setEditNota(false);
        setEditNotaReservada(false);
        let updates = {};
        if (editadoNota) {
            updates.notePubl = opd.notePubl;
        }
        if (editadoNotaReservada) {
            updates.notePriv = opd.notePriv;
        }
        try {
            await modificarOPD(opd._id, updates, []);
            setEditadoNota(false);
            setEditadoNotaReservada(false);
        } catch (error) {
            console.log("Error al guardar cambios en OPD", error);
        }
    };

    return (
        <div className="container-gr-req">
            <div className="container-r-list-item-header-info">
                <div className="label-req">OPD - {opd.tDocNroFor}</div>
                <div className="r-list-item-header-title" style={{ margin: '0 auto', marginTop: '10px' }}>{opd.title}</div>
                <div className="margin-right-r">
                    <div className={opd.priority === 2 ? 'r-list-item-header-priority-urgente' : opd.priority === 1 ? 'r-list-item-header-priority-alta' : 'r-list-item-header-priority-media'}>
                        {PRIORITY[opd.priority ?? 0]}
                    </div>
                </div>
                <button className="minimizarBtn" onClick={() => cerrar()}>X</button>
            </div>

            <div className="container-r-item-details">
                <div className="container-r-info-p">
                    <div className="label-req-title">Estado Actual </div>
                    <div className="r-list-item-details-clave-v">{opd.state}</div>
                    <div className="label-req-title">Emitido por </div>
                    <div className="r-list-item-details-title-v">{opd.userName}</div>
                </div>

                <div className="container-r-item-title-details">Fechas</div>
                <div className="container-r-info-p" style={{ justifyContent: 'flex-start', gap: '2rem' }}>
                    <div>
                        <div className="label-req-title">Alta</div>
                        <div className="r-list-item-details-data-v">{moment(opd.fecAlt).format('DD-MM-YYYY')}</div>
                    </div>
                    <div>
                        <div className="label-req-title">Movimiento</div>
                        <div className="r-list-item-details-data-v">{opd.fecMov ? moment(opd.fecMov).format('DD-MM-YYYY') : '-'}</div>
                    </div>
                    <div>
                        <div className="label-req-title">Entrega</div>
                        <div className="r-list-item-details-data-v">{opd.deliveryDate ? moment(opd.deliveryDate).format('DD-MM-YYYY') : '-'}</div>
                    </div>
                </div>

                {opd.notePubl && <>
                    <div className="container-r-item-title-details">Texto Adicional</div>
                    <div className="container-r-texto">
                        <div className="r-list-item-details-data-v">{opd.notePubl}</div>
                    </div>
                </>}

                {opd.direccion && <>
                    <div className="container-r-item-title-details">Dirección</div>
                    <div className="container-r-texto">
                        <div className="r-list-item-details-data-v">
                            {opd.direccion}
                            {opd.lat && <span style={{ color: 'green', marginLeft: '0.5rem', fontSize: '0.8rem' }}>&#10003; Geocodificada</span>}
                        </div>
                    </div>
                </>}

                {opd.templatesProduccion && opd.templatesProduccion.length > 0 && <>
                    <div className="container-r-item-title-details">Templates de Produccion: {opd.templatesProduccion.length}</div>
                    <div className="container-list-products-r-gral">
                        {opd.templatesProduccion.map((t, idx) => (
                            <div className="container-list-products-r" key={idx}>
                                <div className="container-list-product-r-icon">
                                    <div className="list-item-icon-r"><FontAwesomeIcon icon={faListCheck} /></div>
                                    <div className="list-item-title-r">{t.codTemplate}</div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>{t.name || t.label}</div>
                                    <div className="container-cantidad-product-r">
                                        {t.unidades ? `Unidades: ${t.unidades}` : ''}
                                        {t.metros ? ` | Metros: ${t.metros}` : ''}
                                        {t.kilos ? ` | Kilos: ${t.kilos}` : ''}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>}

                {opd.products && opd.products.length > 0 && <>
                    <div className="container-r-item-title-details">Materiales: {opd.products.length}</div>
                    <div className="container-list-products-r-gral">
                        {opd.products.map((product, idx) => (
                            <div className="container-list-products-r" key={idx}>
                                <div className="container-list-product-r-icon">
                                    <div className="list-item-icon-r"><FontAwesomeIcon icon={faBox} /></div>
                                    <div className="list-item-title-r">{product.codRed}</div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>{product.descrp}</div>
                                    {product.textAdic && <div>{product.textAdic}</div>}
                                    <div className="container-cantidad-product-r">Cantidad: {product.quantity}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>}

                {opd.imputaciones && opd.imputaciones.length > 0 && <>
                    <div className="container-r-item-title-details">Imputaciones RRHH: {opd.imputaciones.length}</div>
                    <div className="container-list-products-r-gral">
                        {opd.imputaciones.map((impu, idx) => (
                            <div className="container-list-products-r" key={idx}>
                                <div className="container-list-product-r-icon">
                                    <div className="list-item-icon-r"><FontAwesomeIcon icon={faSmile} /></div>
                                    <div className="list-item-title-r">{impu.legajo?.value}</div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>{impu.legajo?.label}</div>
                                    {impu.textAdic && <div>{impu.textAdic}</div>}
                                    <div className="container-cantidad-product-r">Cantidad Horas: {impu.cantHoras}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>}

                {opd.tareas && opd.tareas.length > 0 && <>
                    <div className="container-r-item-title-details">Tareas: {opd.tareas.length}</div>
                    <div className="container-list-products-r-gral">
                        {opd.tareas.map((tarea, idx) => (
                            <div className="container-list-products-r" key={idx}>
                                <div className="container-list-product-r-icon">
                                    <div className="list-item-icon-r"><FontAwesomeIcon icon={faClipboardList} /></div>
                                    <div className="list-item-title-r">{tarea.codTarea || tarea.value}</div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>{tarea.descrp || tarea.label}</div>
                                    {tarea.codActivo && <div>Activo: {tarea.activoNombre || tarea.codActivo}</div>}
                                    {tarea.cargaTiempo && <div>Carga de Tiempo: {tarea.cargaTiempo} hs ({Math.round((parseFloat(tarea.cargaTiempo) || 0) * 60)} minutos)</div>}
                                    {tarea.taskDescrp && <div>{tarea.taskDescrp}</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                </>}

                <div className="container-r-item-title-details">
                    <div>Nota</div>
                    {!editNota &&
                        <div className="container-button-download"><button className="button-edit" onClick={handleEditNota}><FontAwesomeIcon icon={faPen} /></button></div>
                    }
                    {editNota &&
                        <div className="container-button-download">
                            <button className="button-edit" onClick={handleEditNota}><FontAwesomeIcon icon={faRectangleXmark} /></button>
                            <button className="button-edit" onClick={saveChanges}><FontAwesomeIcon icon={faFloppyDisk} /></button>
                        </div>
                    }
                </div>
                <div className="container-r-texto">
                    {!editNota &&
                        <div className="r-list-item-details-data-v">{opd.notePubl}</div>
                    }
                    {editNota &&
                        <textarea className="r-textarea-input" value={opd.notePubl || ''} onChange={(e) => handleModificaNota(e.target.value)} />
                    }
                </div>

                <div className="container-r-item-title-details">
                    <div>Nota Reservada</div>
                    {!editNotaReservada &&
                        <div className="container-button-download"><button className="button-edit" onClick={handleEditNotaReservada}><FontAwesomeIcon icon={faPen} /></button></div>
                    }
                    {editNotaReservada &&
                        <div className="container-button-download">
                            <button className="button-edit" onClick={handleEditNotaReservada}><FontAwesomeIcon icon={faRectangleXmark} /></button>
                            <button className="button-edit" onClick={saveChanges}><FontAwesomeIcon icon={faFloppyDisk} /></button>
                        </div>
                    }
                </div>
                <div className="container-r-texto">
                    {!editNotaReservada &&
                        <div className="r-list-item-details-data-v">{opd.notePriv}</div>
                    }
                    {editNotaReservada &&
                        <textarea className="r-textarea-input" value={opd.notePriv || ''} onChange={(e) => handleModificaNotaReservada(e.target.value)} />
                    }
                </div>

                <div className="container-r-item-title-details">
                    <div>Archivos</div>
                    {files && files.length > 0 && (
                        <div className="container-button-download">
                            <button className="button-download" onClick={handleDownloadAll}>
                                Descargar Todos <FontAwesomeIcon icon={faDownload} />
                            </button>
                        </div>
                    )}
                </div>
                <div className="container-files-rq">
                    <ul className="container-files-rq-details">
                        {files?.map((file) => (
                            <li className="container-files-rq-details-items" key={file.name} onClick={() => handleAbrirURL(file.url)}>{file.name}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="rq-container-buttons-bottom">
                <div className="rq-button-bottom" onClick={() => generarInformeReqPDF(opd, usuario)}><FontAwesomeIcon icon={faFilePdf} /> PDF</div>
                <div className="rq-button-bottom" onClick={() => generarInformeReqPDF(opd, usuario, true)}><FontAwesomeIcon icon={faFilePdf} /> PDF con Logo</div>
            </div>
        </div>
    );
}

export default OPDInfo;
